import util from '@bmp-vue/core/api/util'

const controller = 'Credenciadora'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'post', 'put', 'persist']), {})
